const ajax_post_filter = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const form = document.getElementById('filter-form');
        const resultsContainer = document.getElementById('filter-results');
        const postTypeButtons = document.querySelectorAll('.post-type-btn');
        const postTypeInput = form.querySelector('input[name="post_type"]');
        let currentPage = 1;

        const loadMoreBtn = document.getElementById('load-more');

        postTypeButtons.forEach(button => {
            button.addEventListener('click', function () {
                postTypeButtons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');
                postTypeInput.value = this.getAttribute('data-post-type');
                currentPage = 1;
                sendFilterRequest(true);
            });
        });

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            currentPage = 1;
            sendFilterRequest(true);
        });

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function () {
                currentPage++;
                sendFilterRequest(false);
            });
        }

        function sendFilterRequest(resetResults = false) {
            const formData = new FormData(form);
            formData.append('action', 'filter_posts');
            formData.append('paged', currentPage);

            fetch(dataAjax.ajaxUrl, {
                method: 'POST',
                body: new URLSearchParams(formData)
            })
                .then(res => res.json())
                .then(data => {
                    if (resetResults) {
                        resultsContainer.innerHTML = data.html;
                    } else {
                        resultsContainer.insertAdjacentHTML('beforeend', data.html);
                    }

                    if (data.has_more) {
                        loadMoreBtn.style.display = 'block';
                    } else {
                        loadMoreBtn.style.display = 'none';
                    }
                })
                .catch(error => {
                    console.error('AJAX error:', error);
                });
        }

        // Инициализируем первый запрос
        sendFilterRequest(true);


        /**
         * START Clear all category vertical
         */
        const container = document.querySelector('.filter-group-vertical');
        if (!container) return;

        const checkboxes = container.querySelectorAll('input[name="vertical-category[]"]');
        const counterSpan = document.getElementById('count-vertical-category');
        const clearButton = document.getElementById('btn-clear-vertical');

        const updateCount = () => {
            const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;
            counterSpan.textContent = checkedCount;
            currentPage = 1;
            sendFilterRequest(true);
        };

        checkboxes.forEach(cb => {
            cb.addEventListener('change', updateCount);
        });

        if (clearButton) {
            clearButton.addEventListener('click', () => {
                checkboxes.forEach(cb => cb.checked = false);
                updateCount();
            });
        }

        updateCount();

        /**
         * START Clear all category media
         */
        const mediaCheckboxes = document.querySelectorAll('input[name="media-strategy-category[]"]');
        const mediaCounter = document.getElementById('count-media-category');
        const clearMediaBtn = document.getElementById('btn-clear-media');

        if (!mediaCheckboxes.length || !mediaCounter || !clearMediaBtn) return;

        const updateMediaCount = () => {
            const selected = Array.from(mediaCheckboxes).filter(cb => cb.checked).length;
            mediaCounter.textContent = selected;
            currentPage = 1;
            sendFilterRequest(true);
        };

        mediaCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', updateMediaCount);
        });

        clearMediaBtn.addEventListener('click', () => {
            mediaCheckboxes.forEach(cb => cb.checked = false);
            updateMediaCount();
        });

        updateMediaCount();

        /**
         * START Clear all category DSO
         */
        const dsoCheckboxes = document.querySelectorAll('input[name="dso-scenario-category[]"]');
        const dsoCounter = document.getElementById('count-dso-category');
        const clearDsoBtn = document.getElementById('btn-clear-dso');

        if (!dsoCheckboxes.length || !dsoCounter || !clearDsoBtn) return;

        const updateDsoCount = () => {
            const selected = Array.from(dsoCheckboxes).filter(cb => cb.checked).length;
            dsoCounter.textContent = selected;
            currentPage = 1;
            sendFilterRequest(true);
        };

        dsoCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', updateDsoCount);
        });

        clearDsoBtn.addEventListener('click', () => {
            dsoCheckboxes.forEach(cb => cb.checked = false);
            updateDsoCount();
        });

        updateDsoCount();

        /**
         * START Clear all category format
         */
        const formatCheckboxes = document.querySelectorAll('input[name="format-category[]"]');
        const formatCounter = document.getElementById('count-format-category');
        const clearFormatBtn = document.getElementById('btn-clear-format');

        if (!formatCheckboxes.length || !formatCounter || !clearFormatBtn) return;

        const updateFormatCount = () => {
            const selected = Array.from(formatCheckboxes).filter(cb => cb.checked).length;
            formatCounter.textContent = selected;
            currentPage = 1;
            sendFilterRequest(true);
        };

        formatCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', updateFormatCount);
        });

        clearFormatBtn.addEventListener('click', () => {
            formatCheckboxes.forEach(cb => cb.checked = false);
            updateFormatCount();
        });

        updateFormatCount();
    });
};

export default ajax_post_filter;
